import type { Member } from '@domain/state.ts'
import { es } from '../strings/es.ts'

/**
 * Cuál de los adultos está usando la tablet.
 *
 * Sale solo cuando hay más de uno. Antes, todo lo que se validaba quedaba a
 * nombre de la primera persona que se dio de alta, lo cual convertía el registro
 * en una historia falsa en cuanto había dos adultos en la casa: «papá validó» el
 * día que estaba trabajando fuera.
 *
 * Después del PIN y no antes: el PIN es de la casa —una sola cosa que recordar—
 * y esto es una firma, no una contraseña.
 */
export function QuienAdulto({
  adultos,
  onElegir,
  onCancel,
}: {
  adultos: readonly Member[]
  onElegir: (memberId: Member['id']) => void
  onCancel: () => void
}) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-5">
      <h1 className="mb-1 text-3xl font-extrabold tracking-tight">{es.who.cualAdulto}</h1>
      <p className="text-muted mt-0 mb-6 text-sm">{es.who.cualAdultoHelp}</p>

      <ul className="grid list-none gap-3 p-0">
        {adultos.map((adulto) => (
          <li key={adulto.id} className="m-0">
            <button
              type="button"
              className="border-rule bg-surface w-full rounded-xl border p-5 text-left text-xl font-bold"
              onClick={() => {
                onElegir(adulto.id)
              }}
            >
              {adulto.name}
            </button>
          </li>
        ))}
      </ul>

      <button type="button" className="text-muted mt-8 text-sm font-bold" onClick={onCancel}>
        {es.pin.cancel}
      </button>
    </div>
  )
}
